// extracted by mini-css-extract-plugin
export var alertIcon = "_qs-0";